import { createContext, useState, useCallback, useMemo } from 'react';

import { AisOrder, ResearchSheet } from 'types';

interface ReworkCtxType {
  aisOrder?: AisOrder;
  researchSheet?: ResearchSheet;
  handleAisOrder?: (aisOrder?: AisOrder) => void;
  handleResearchSheet?: (researchSheet?: ResearchSheet) => void;
  clearContext?: () => void;
}

export const ReworkCtx = createContext<ReworkCtxType>({});

export function useReworkCtx() {
  const [aisOrder, setAisOrder] = useState<AisOrder | undefined>();
  const [researchSheet, setResearchSheet] = useState<
    ResearchSheet | undefined
  >();

  const handleAisOrder = useCallback((aisOrder?: AisOrder) => {
    setAisOrder(aisOrder);
    setResearchSheet(undefined);
  }, []);

  const handleResearchSheet = useCallback((researchSheet?: ResearchSheet) => {
    setAisOrder(undefined);
    setResearchSheet(researchSheet);
  }, []);

  const clearContext = useCallback(() => {
    setAisOrder(undefined);
    setResearchSheet(undefined);
  }, []);

  const reworkCtx: ReworkCtxType = useMemo(
    () => ({
      aisOrder,
      researchSheet,
      handleAisOrder,
      handleResearchSheet,
      clearContext,
    }),
    [aisOrder, clearContext, handleAisOrder, handleResearchSheet, researchSheet]
  );

  return reworkCtx;
}
